import React from 'react';
import classnames from 'classnames';

export interface IFindingCountProps {
  count: number;
  tooltip?: string;
  showIncomplete?: boolean;
  title?: string;
}

const FindingCount: React.FC<IFindingCountProps> = ({
  count = 0,
  tooltip = '',
  showIncomplete = false,
  title,
}) => {
  return (
    <div title={tooltip}>
      <span className='finding-count-title'>{title}:</span>
      <span
        className={classnames('icon-only-button tiny outline', {
          inCompleteFindings: showIncomplete && count > 0,
        })}
      >
        {count}
      </span>
    </div>
  );
};

export default FindingCount;
